import { AllocationData } from '../../types/tokenomics';
import { H3, H4, Body, BodySmall } from '../ui/Typography';

interface TokenAllocationProps {
  allocation: AllocationData;
}

export default function TokenAllocation({ allocation }: TokenAllocationProps) {
  return (
    <div className="bg-gray-50 p-6 rounded-lg">
      <div className="flex flex-col md:flex-row justify-between items-start gap-8">
        <div className="w-full md:w-1/3">
          <H3 className="text-gray-900 mb-2">{allocation.title}</H3>
          <p className="text-3xl font-bold text-primary mb-1">{allocation.percentage}</p>
          <Body className="text-gray-600">{allocation.tokens} tokens</Body>
        </div>
        <div className="w-full md:w-2/3 bg-white p-6 rounded-lg shadow-sm min-h-[160px]">
          <H4 className="text-gray-900 mb-4">{allocation.scheduleTitle}</H4>
          <ul className="space-y-3">
            {allocation.schedule.map((item: string, i: number) => (
              <li key={i} className="flex items-center">
                <span className="w-2 h-2 bg-secondary rounded-full mr-2 shrink-0"></span>
                <Body className="text-gray-600">{item}</Body>
              </li>
            ))}
          </ul>
          {allocation.note && (
            <BodySmall className="mt-4 text-gray-500 italic">{allocation.note}</BodySmall>
          )}
        </div>
      </div>
    </div>
  );
}